export default `

.btn-default-wl {
  background-color: var(--button-primary-color) !important;
  color: var(--button-secondary-color) !important;
  border:none;
  width: 90%;
  &:disabled {
    background-color: var(--text-dark) !important;
  }
}

.btn-cancel-wl {
  border-color: var(--button-primary-color) !important;
  border-radius: 9px;
  width: 90%;
  &:disabled {
    border-color: var(--text-dark) !important;
  }
}

.btn-default-outline-wl {
  background-color: var(--light-wl-gray) !important;
  color: white !important;
  border-radius: 9px;
  border:none;
  width: 90%;
}

.btn-outline-wl {
  background-color: white !important;
  color: var(--button-primary-color) !important;
  border-radius: 0px;
  border: 1px solid var(--button-primary-color) !important;
  width: 90%;
}
`;
